// src/routers/HrRouter.js
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import useAuthRole from '../Hooks/useAuthRole'; // ✅ use the role hook

const HrRouter = ({ children, ...rest }) => {
  const { user, isLoading, isHrPlus } = useAuthRole();
  // isHrPlus === hr OR moderator OR admin (as per your hook definition)

  if (isLoading) {
    return (
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    );
  }

  const isSignedIn = !!user?.email;
  const canAccess = isSignedIn && isHrPlus;

  return (
    <Route
      {...rest}
      render={({ location }) =>
        canAccess ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default HrRouter;
